import Sheet from './Sheet'
import type { RefusalNotice } from '../api/refusals'

interface Props {
	notice: RefusalNotice | null
	onClose: () => void
}

// Оспорить решение модерации — в Telegram из п. 9.5 оферты (п. 10.6). Чат поддержки на сайте уходит в доску заявок
// админки, которую сейчас не разбирают (владелец, 10.10) — туда окно больше не ведёт; почту владелец не показывать решил.
const APPEAL_TELEGRAM = 'https://t.me/partnershipsads'

/** Окно отказа нейросети за нарушение правил: первый раз — предупреждение (токены вернули), после предупреждения —
 *  «токены списаны». Тексты — с сервера (группа отказа, правятся в админке «Отказы нейросетей»). */
export default function RefusalNoticeModal({ notice, onClose }: Props) {
	const charged = notice?.action === 'charge'
	return (
		<Sheet open={!!notice} onClose={onClose} variant="center" className="refusal-sheet" contentClassName="refusal-sheet__content">
			{notice && (
				<div className="nsfw-modal refusal-modal" role="alertdialog" aria-labelledby="refusal-modal-title">
					<svg className="refusal-modal__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8"
						strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
						{charged ? (
							<>
								<circle cx="12" cy="12" r="10" />
								<path d="m4.9 4.9 14.2 14.2" />
							</>
						) : (
							<>
								<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
								<path d="M12 8v4" />
								<path d="M12 16h.01" />
							</>
						)}
					</svg>
					<h3 className="nsfw-modal-title" id="refusal-modal-title">
						{charged
							? `Токены списаны${notice.credits > 0 ? `: ${Math.round(notice.credits)}` : ''}`
							: 'Запрос нарушает правила'}
					</h3>
					{(notice.title || (notice.count ?? 1) > 1) && (
						<p className="refusal-modal__group">
							{notice.title && <span className="refusal-modal__tag">{notice.title}</span>}
							{(notice.count ?? 1) > 1 && <span className="refusal-modal__count">отказов: {notice.count}</span>}
						</p>
					)}
					<p className="nsfw-modal-body">
						{notice.text ||
							(charged
								? 'Повторный запрос, нарушающий правила. Нейросеть отказала, а после предупреждения токены за такие запросы не возвращаются.'
								: 'Такой контент запрещено генерировать. За эту попытку токены не берём, но следующие запросы, нарушающие правила, будут списывать токены, даже если нейросеть откажет.')}
					</p>
					{charged && (
						<p className="nsfw-modal-warning">
							Измените запрос — обычные генерации работают как раньше. Если считаете, что это ошибка, напишите в
							поддержку: проверим и, если ошибка подтвердится, вернём токены.
						</p>
					)}
					<button className="nsfw-modal-btn" type="button" onClick={onClose}>
						Понятно
					</button>
					{charged && (
						<a className="refusal-modal__support" href={APPEAL_TELEGRAM} target="_blank" rel="noreferrer" onClick={onClose}>
							Написать в поддержку
						</a>
					)}
					<a className="refusal-modal__rules" href="/offer#o10" target="_blank" rel="noreferrer">
						Правила платформы, раздел 10
					</a>
				</div>
			)}
		</Sheet>
	)
}
